(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("underscore"), require("tc39-proposal-temporal"), require("@bingads-webui-universal/time-zone-converter"));
	else if(typeof define === 'function' && define.amd)
		define(["underscore", "tc39-proposal-temporal", "@bingads-webui-universal/time-zone-converter"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("underscore"), require("tc39-proposal-temporal"), require("@bingads-webui-universal/time-zone-converter")) : factory(root["underscore"], root["tc39-proposal-temporal"], root["@bingads-webui-universal/time-zone-converter"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__7__, __WEBPACK_EXTERNAL_MODULE__91__, __WEBPACK_EXTERNAL_MODULE__95__) {
return 